import React, { useState } from 'react';
import {Modal, Input } from 'antd';
import styles from "./createNote.module.scss";
import { URButton } from '../../widgets/button';
import TextArea from 'antd/lib/input/TextArea';
import { contactService } from '../../../base/contactService';

type createNoteProps = {
  open: boolean;
  openNote: (status: boolean) => void;
}
type CreateNoteState = {
  title: any;
  description: any;
  key:string;
  errors:boolean
}
export default function Createnote({ open, openNote }: createNoteProps) {
  const [state, setstate] = useState<CreateNoteState>({ title: "", description: "", errors:false,key:"login"});
 
  const onChangeInpout = (e: any) => {
    setstate({ ...state, [e.target.name]: e.target.value , errors:false});
  };

  const onCancel = () => {
    setstate({ ...state, title: "", description: "" ,errors:false});
    openNote(false);
   
  };

  const onSend = () => {
    if(state.title.trim() === ""){
      setstate({ ...state, errors:true });
      return;
    } else {
      contactService.createContactNote(state,state.key);
      setstate({ ...state, title: "", description: "", errors:false });
      openNote(false);
    }
  };

  return (
    <>
      <Modal visible={open} className={`${styles.newmessage} ${"modaloverwrite"} ${"notecreation"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={onCancel} />
        <h2>New Note <span className="icon_event"></span></h2>
        <div className={styles.createNoteBody}>
          <div className={styles.inputfield}>
          <Input placeholder="Title" name="title" value={state.title} maxLength={40}
              className={`${styles.notesTitle} ${styles.inputarea}`} onChange={onChangeInpout}></Input>
          </div>
          {state.errors && <p className={styles.errors}>This note needs a title </p>}
          {/* <h3>Description</h3> */}
          <div className={styles.inputfield}>
            <TextArea
              name="description"
              onChange={onChangeInpout}
              value={state.description}
              placeholder="Start writing or drag files"
              autoSize={{ minRows: 3, maxRows: 5 }}
              className={styles.notesDesc}
            />
          </div>
          {/* {state.errors && <h3 className={styles.errors}>All fields are mandatory</h3>} */}
        </div>
        
        <div className={`${styles.footersection} ${"footersection"}`}>
          <URButton onClick={onCancel} name="Cancel" className="urButton buttonWhite" />
          <URButton onClick={onSend} name="Save" className="urButton buttonBlue marlftmin" />
        </div>
      </Modal>
    </>
  );
}

